"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var isActiveParcel = function isActiveParcel(parcel) {
  return parcel.quantity !== 0;
};

var parcelsAdapter = function parcelsAdapter(parcels) {
  return parcels.filter(isActiveParcel);
};

var _default = parcelsAdapter;
exports.default = _default;
module.exports = exports.default;